import { Routes, Route, Navigate } from "react-router-dom";
import { NistCsfPage } from "../pages/NistCsf";
import { DashboardPage } from "../pages/Dashboard";
import { StatementOfApplicabilityPage } from "../pages/StatementOfApplicability";
import { DocumentsPage } from "../pages/Documents";
import { OrgProfilePage } from "../pages/OrgProfile";
import { ProfilePage } from "../pages/ProfilePage";
import { MyServicesPage } from "../pages/MyServices";
import { ActivityLogPage } from "../pages/ActivityLog";
import { HelpPage } from "../pages/Help";
import { PlaybooksPage } from "../pages/help/PlaybooksPage";
import { LibraryPage } from "../pages/help/LibraryPage";
import { AskRegistersPage } from "../pages/AskRegisters";
import { ContinuousGuidancePage } from "../pages/ContinuousGuidance";
import { ComplianceCheckPage } from "../pages/ComplianceCheck";
import { Iso27001Page } from "../pages/Iso27001";
import { PolicyTemplatesPage } from "../pages/PolicyTemplates";
import { PoliciesPage } from "../pages/Policies";
import { ConnectM365Page } from "../pages/ConnectM365";
import { ConnectGooglePage } from "../pages/ConnectGoogle";
import { ConnectStoragePage } from "../pages/ConnectStorage";
import { ConnectionsPage } from "../pages/Connections";
import { SchedulePage } from "../pages/Schedule";
import { AuditorFeedbackPage } from "../pages/AuditorFeedback";
import { ExecutiveReportPage } from "../pages/ExecutiveReport";
import { CyberEssentialsPage } from "../pages/CyberEssentials";
import { IasmeCaAssessmentPage } from "../pages/IasmeCaAssessment";
import { Iso42001Page } from "../pages/Iso42001";
import { Iso42001SoaPage } from "../pages/Iso42001Soa";
import { Iso9001Page } from "../pages/Iso9001";
import { Iso9001SoaPage } from "../pages/Iso9001Soa";
import { Iso9002Page } from "../pages/Iso9002";
import { Iso45001SoaPage } from "../pages/Iso45001Soa";
import { Soc2Page } from "../pages/Soc2";
import { PciDssPage } from "../pages/PciDss";
import { ConsultancyTimePage } from "../pages/ConsultancyTime";
import { WhatsNewPage } from "../pages/WhatsNew";
import { TeamPage } from "../pages/Team";
import { ComplianceQuestionsPage } from "../pages/ComplianceQuestions";
import { LegalCompliancePage } from "../pages/LegalCompliance";
import { RiskRegisterPage } from "../pages/RiskRegister";
import { ControlMappingPage } from "../pages/ControlMapping";
import { DataProtectionMappingPage } from "../pages/DataProtectionMapping";
import { TprmPage } from "../pages/Tprm";
import { DoraMonitoringPage } from "../pages/DoraMonitoring";
import { GdprPage } from "../pages/GdprPage";
import { DepartmentsPage } from "../pages/Departments";
import { SitesPage } from "../pages/Sites";
import { SiteDetailPage } from "../pages/SiteDetail";
import { GroupOverviewPage } from "../pages/GroupOverview";
import { HardeningPage } from "../pages/Hardening";
import { ThreatAdvisoriesPage } from "../pages/ThreatAdvisories";
import { PublicApiPage } from "../pages/PublicApiPage";
import { Iso45001Page } from "../pages/Iso45001Page";
import { Iso14001Page } from "../pages/Iso14001Page";
import { Iso14001SoaPage } from "../pages/Iso14001SoaPage";
import { Iwa48Page } from "../pages/Iwa48Page";
import { ActionsPage } from "../pages/ActionsPage";
import { GuidesPage } from "../pages/GuidesPage";
import { MoreToolsPage } from "../pages/MoreToolsPage";
import { AnalyticsPage } from "../pages/AnalyticsPage";
import { EvidenceExportPage } from "../pages/EvidenceExport";
import { ResiliencePage } from "../pages/resilience/ResiliencePage";
import { ResponseRoomPage, ResponseRoomsPage } from "../pages/resilience/ResponseRooms";
import { ImprovementRegisterPage } from "../pages/ImprovementRegister";
import { ManagementSystemPage } from "../pages/managementSystem/ManagementSystemPage";
import { EstatePage } from "../pages/EstatePage";
import { AiSystemsPage } from "../pages/AiSystemsPage";
import { SubmissionsPage } from "../pages/SubmissionsPage";
import { NcscCafPage, NcscCafSoaPage } from "../pages/NcscCafPage";
import { PolicyGovernancePage } from "../pages/PolicyGovernancePage";
import { MyTasksPage } from "../pages/MyTasksPage";
import { AssurancePacksPage } from "../pages/AssurancePacksPage";
import { VulnerabilitiesPage } from "../pages/VulnerabilitiesPage";
import { ExposurePage } from "../pages/ExposurePage";
import { RemediationPage } from "../pages/RemediationPage";
import { PeopleLifecyclePage } from "../pages/PeopleLifecyclePage";
import { AccessReviewsPage } from "../pages/AccessReviewsPage";
import { MockAuditPage } from "../pages/MockAuditPage";
import { RemediationRoadmapPage } from "../pages/RemediationRoadmapPage";
import { PolicyExceptionsPage } from "../pages/PolicyExceptionsPage";
import { ChangeRegisterPage } from "../pages/ChangeRegisterPage";
import { DevicesPage } from "../pages/DevicesPage";
import { DeviceDetailPage } from "../pages/DeviceDetailPage";
import { CustomerQuestionnairesPage } from "../pages/CustomerQuestionnairesPage";
import { DataDiscoveryPage } from "../pages/DataDiscoveryPage";
import { OperatingParametersPage } from "../pages/OperatingParametersPage";
import { TechnicalScopesPage } from "../pages/TechnicalScopesPage";
import { StandardGate, CyberEssentialsRoute } from "./standards/StandardGate";

// ── Client routes ─────────────────────────────────────────────────────────
// Every client page, with RELATIVE paths so the same block mounts at the root
// (ClientLayout) and under /consultant/clients/:orgId/portal/* (the consultant
// read-through). Leading slashes are forbidden here: a descendant <Routes>
// resolves them against the root and the read-through would break.
//
// Redirect targets are relative too. Inside the index and the "pci-dss" route
// a bare "actions" / "saq-a" resolves against the parent path. Inside a splat
// ("*") route react-router 7 resolves relative paths against the full matched
// pathname (the splat included), so the catch-all uses "../actions" to land on
// <mount>/actions rather than <mount>/<junk>/actions. Verified against
// react-router 7.18 at the root and under the read-through mount.

export function ClientRoutes() {
  return (
    <Routes>
      {/* Home is What's next: the one ranked list of what to do (docs/NAVIGATION.md section 4). */}
      <Route index element={<Navigate to="actions" replace />} />
      <Route path="dashboard" element={<DashboardPage />} />
      <Route path="actions" element={<ActionsPage />} />
      <Route path="guides" element={<GuidesPage />} />
      <Route path="more-tools" element={<MoreToolsPage />} />
      <Route path="analytics" element={<AnalyticsPage />} />
      <Route path="iso27001-soa" element={<StandardGate frameworkId="iso27001"><StatementOfApplicabilityPage /></StandardGate>} />
      <Route path="documents" element={<DocumentsPage />} />
      <Route path="export" element={<EvidenceExportPage />} />
      <Route path="org-profile" element={<OrgProfilePage />} />
      <Route path="profile" element={<ProfilePage />} />
      <Route path="my-services" element={<MyServicesPage />} />
      <Route path="activity-log" element={<ActivityLogPage />} />
      <Route path="operating-parameters" element={<OperatingParametersPage />} />
      <Route path="help" element={<HelpPage />} />
      <Route path="playbooks" element={<PolicyTemplatesPage playbooks />} />
      <Route path="help/playbooks" element={<PlaybooksPage />} />
      <Route path="help/playbooks/:playbookId" element={<PlaybooksPage />} />
      <Route path="help/library" element={<LibraryPage />} />
      <Route path="help/library/:docId" element={<LibraryPage />} />
      <Route path="help/ask" element={<AskRegistersPage />} />
      <Route path="guidance" element={<ContinuousGuidancePage />} />
      <Route path="compliance" element={<ComplianceCheckPage />} />
      <Route path="mandatory-clauses" element={<StandardGate frameworkId="iso27001"><Iso27001Page tab="clauses" /></StandardGate>} />
      <Route path="annex-a" element={<StandardGate frameworkId="iso27001"><Iso27001Page tab="controls" /></StandardGate>} />
      <Route path="templates" element={<PolicyTemplatesPage />} />
      <Route path="policies" element={<PoliciesPage />} />
      <Route path="connections" element={<ConnectionsPage />} />
      <Route path="m365" element={<ConnectM365Page />} />
      <Route path="google" element={<ConnectGooglePage />} />
      <Route path="storage" element={<ConnectStoragePage />} />
      <Route path="schedule" element={<SchedulePage />} />
      <Route path="auditor-feedback" element={<AuditorFeedbackPage />} />
      <Route path="executive-report" element={<ExecutiveReportPage />} />
      <Route path="cyber-essentials" element={<CyberEssentialsRoute><CyberEssentialsPage /></CyberEssentialsRoute>} />
      <Route path="cyber-essentials-plus" element={<StandardGate frameworkId="cyber_essentials_plus"><CyberEssentialsPage plus /></StandardGate>} />
      <Route path="iso42001" element={<StandardGate frameworkId="iso42001"><Iso42001Page tab="clauses" /></StandardGate>} />
      <Route path="iso42001-soa" element={<StandardGate frameworkId="iso42001"><Iso42001SoaPage /></StandardGate>} />
      <Route path="iso42002" element={<StandardGate frameworkId="iso42001"><Iso42001Page tab="controls" /></StandardGate>} />
      <Route path="iso42001-controls" element={<Navigate to="../iso42002" replace />} />
      <Route path="iso9001" element={<StandardGate frameworkId="iso9001"><Iso9001Page /></StandardGate>} />
      <Route path="iso9001-soa" element={<StandardGate frameworkId="iso9001"><Iso9001SoaPage /></StandardGate>} />
      <Route path="iso9002" element={<StandardGate frameworkId="iso9001"><Iso9002Page /></StandardGate>} />
      <Route path="soc2" element={<StandardGate frameworkId="soc2"><Soc2Page /></StandardGate>} />
      <Route path="iasme-ca-sole-trader"  element={<StandardGate frameworkId="iasme_ca_sole_trader"><IasmeCaAssessmentPage frameworkId="iasme_ca_sole_trader" /></StandardGate>} />
      <Route path="iasme-ca-micro"        element={<StandardGate frameworkId="iasme_ca_micro"><IasmeCaAssessmentPage frameworkId="iasme_ca_micro" /></StandardGate>} />
      <Route path="iasme-ca-small"        element={<StandardGate frameworkId="iasme_ca_small"><IasmeCaAssessmentPage frameworkId="iasme_ca_small" /></StandardGate>} />
      <Route path="iasme-ca-medium-large" element={<StandardGate frameworkId="iasme_ca_medium_large"><IasmeCaAssessmentPage frameworkId="iasme_ca_medium_large" /></StandardGate>} />
      <Route path="pci-dss/:saqType" element={<StandardGate frameworkId="pci_dss"><PciDssPage /></StandardGate>} />
      <Route path="pci-dss" element={<Navigate to="saq-a" replace />} />
      <Route path="consultancy-time" element={<ConsultancyTimePage />} />
      <Route path="whats-new" element={<WhatsNewPage />} />
      <Route path="team" element={<TeamPage />} />
      <Route path="compliance-questions" element={<ComplianceQuestionsPage />} />
      <Route path="legal" element={<LegalCompliancePage />} />
      <Route path="data-protection-mapping" element={<DataProtectionMappingPage />} />
      <Route path="risk-register" element={<RiskRegisterPage />} />
      <Route path="control-mapping" element={<ControlMappingPage />} />
      <Route path="tprm" element={<TprmPage />} />
      <Route path="dora" element={<DoraMonitoringPage />} />
      <Route path="nist-csf" element={<NistCsfPage />} />
      <Route path="gdpr" element={<GdprPage />} />
      <Route path="gdpr/breaches" element={<GdprPage />} />
      <Route path="gdpr/dsr" element={<GdprPage />} />
      <Route path="gdpr/dpia" element={<GdprPage />} />
      <Route path="gdpr/ropa" element={<GdprPage />} />
      <Route path="gdpr/agreements" element={<GdprPage />} />
      <Route path="public-api" element={<PublicApiPage />} />
      <Route path="iso45001" element={<StandardGate frameworkId="iso45001"><Iso45001Page /></StandardGate>} />
      <Route path="iso45001-soa" element={<StandardGate frameworkId="iso45001"><Iso45001SoaPage /></StandardGate>} />
      <Route path="iso14001" element={<StandardGate frameworkId="iso14001"><Iso14001Page /></StandardGate>} />
      <Route path="iso14001-soa" element={<StandardGate frameworkId="iso14001"><Iso14001SoaPage /></StandardGate>} />
      <Route path="iwa48" element={<StandardGate frameworkId="iwa48"><Iwa48Page /></StandardGate>} />
      <Route path="departments" element={<DepartmentsPage />} />
      <Route path="sites" element={<SitesPage />} />
      <Route path="sites/:siteId" element={<SiteDetailPage />} />
      <Route path="group" element={<GroupOverviewPage />} />
      <Route path="hardening" element={<HardeningPage />} />
      <Route path="threat-intelligence" element={<ThreatAdvisoriesPage />} />
      <Route path="resilience" element={<ResiliencePage tab="overview" />} />
      <Route path="resilience/incidents" element={<ResiliencePage tab="incidents" />} />
      <Route path="resilience/exercises" element={<ResiliencePage tab="exercises" />} />
      <Route path="resilience/training" element={<ResiliencePage tab="training" />} />
      <Route path="resilience/assets" element={<ResiliencePage tab="assets" />} />
      <Route path="improvement" element={<ImprovementRegisterPage />} />
      <Route path="management-system" element={<ManagementSystemPage tab="overview" />} />
      <Route path="management-system/context" element={<ManagementSystemPage tab="context" />} />
      <Route path="management-system/objectives" element={<ManagementSystemPage tab="objectives" />} />
      <Route path="management-system/audits" element={<ManagementSystemPage tab="audits" />} />
      <Route path="management-system/reviews" element={<ManagementSystemPage tab="reviews" />} />
      <Route path="management-system/competence" element={<ManagementSystemPage tab="competence" />} />
      <Route path="management-system/aspects" element={<ManagementSystemPage tab="aspects" />} />
      <Route path="management-system/hazards" element={<ManagementSystemPage tab="hazards" />} />
      <Route path="management-system/obligations" element={<ManagementSystemPage tab="obligations" />} />
      <Route path="estate" element={<EstatePage />} />
      <Route path="ai-systems" element={<AiSystemsPage />} />
      <Route path="submissions" element={<SubmissionsPage />} />
      <Route path="resilience/insurance" element={<ResiliencePage tab="insurance" />} />
      <Route path="resilience/bia" element={<ResiliencePage tab="bia" />} />
      <Route path="resilience/rooms" element={<ResponseRoomsPage />} />
      <Route path="resilience/rooms/:roomId" element={<ResponseRoomPage />} />
      <Route path="ncsc-caf" element={<NcscCafPage />} />
      <Route path="ncsc-caf-soa" element={<NcscCafSoaPage />} />
      <Route path="policy-governance" element={<PolicyGovernancePage />} />
      <Route path="technical-scopes" element={<TechnicalScopesPage />} />
      <Route path="policy-exceptions" element={<PolicyExceptionsPage />} />
      <Route path="changes" element={<ChangeRegisterPage />} />
      <Route path="devices" element={<DevicesPage />} />
      <Route path="devices/:id" element={<DeviceDetailPage />} />
      <Route path="customer-questionnaires" element={<CustomerQuestionnairesPage />} />
      <Route path="mock-audits" element={<MockAuditPage />} />
      <Route path="remediation-roadmap" element={<RemediationRoadmapPage />} />
      <Route path="my-tasks" element={<MyTasksPage />} />
      <Route path="assurance-sharing" element={<AssurancePacksPage />} />
      <Route path="vulnerabilities" element={<VulnerabilitiesPage />} />
      <Route path="exposure" element={<ExposurePage />} />
      <Route path="remediation" element={<RemediationPage />} />
      <Route path="people" element={<PeopleLifecyclePage />} />
      <Route path="access-reviews" element={<AccessReviewsPage />} />
      <Route path="data-discovery" element={<DataDiscoveryPage />} />
      <Route path="*" element={<Navigate to="../actions" replace />} />
    </Routes>
  );
}
